module.exports = __webpack_public_path__ + "static/media/city.9cc93111.jpg";